import React from "react";
import * as Modal from "react-modal";

// import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import isEmpty from "lodash/isEmpty";
import moment from "moment";

// import Validator from 'validator';
import { bindActionCreators } from "redux";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import * as _ from "lodash";
import PropTypes from "prop-types";
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-day-picker/lib/style.css";
import "react-toastify/dist/ReactToastify.css";
import { DatePickerInput } from "rc-datepicker";
import AddVehicleInModalSuccess from "./addvehicleSuccess";
import "rc-datepicker/lib/style.css";
import loader from "../../images/Spin-1s-107px.gif";
import Select from "react-select";

import {
  getAllVehicleYear,
  getExternalVehicleDataById,
  getAllVehicleMake,
  getAllVehicleModel,
  getAllVehicleTrim,
  addVehicleData,
  getAllVehicleDataByUserId,
  deleteVehicleRecordsData,
  viewVehicleEditRecord,
  saveMultipleVehicleData,
  getAllVehicleModelClear,
  getAllVehicleTrimClear,
  getAllVehicleMakeClear,
  getConsumerUser,
  updateAutoSettlementFlag
} from "../../Actions/actions";
// import TextFieldGroup from "./TextFieldGroup";
import TextFieldGroupVin from "./vinTextField";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};

class AddVehicleInModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpenVehicle: false,
      userId: localStorage.getItem("userId"),
      yearId: "",
      makeId: "",
      modelId: "",
      trimId: "",
      startDate: "",
      endDate: "",
      vin: "",
      errors: {},
      vehicleUserData1: [],
      showButton1: true,
      addVehicle1: [],
      showUpadeButtonR: true,
      vehicleId: "",
      vehicleViewData1: "",
      date: new Date(),
      vehicleCostId: "",
      vehicleTypeId: "",
      disabledDay: false,
      checkYear: new Date().getFullYear(),
      successSaveState: false,
      vehicleFrom1: false,
      vehicleFrom2: false,
      vehicleFrom3: false,
      vehicleDataExternal1: [],
      recentAnswer: [],
      updateAnswer: [],
      vehicleDataDtos: [],
      vehicleDataExternalSave1: [],
      statePopClose: false,
      autoUdateUserSuccess: [],
      loaded: false,
      fromInfutor: 1
    };
    this.onChange = this.onChange.bind(this);
    this._modelSelect = this._modelSelect.bind(this);
    // this._trimSelect = this._trimSelect.bind(this);
    this._makeYearSelect = this._makeYearSelect.bind(this);
    this._yearSelect = this._yearSelect.bind(this);
    this.openModalVehicle = this.openModalVehicle.bind(this);
    this.closeModalVehicle = this.closeModalVehicle.bind(this);
    this._trimSelect = this._trimSelect.bind(this);
    this._costSelect = this._costSelect.bind(this);
    this._typeSelect = this._typeSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleSubmitVehicle = this.handleSubmitVehicle.bind(this);
    this.handleUpdateVehicle = this.handleUpdateVehicle.bind(this);
    this.handleLog = this.handleLog.bind(this);
    // this.handleLogA = this.handleLogA.bind(this);
    this.handleLog1 = this.handleLog1.bind(this);
    this.vehicleOptionsSelection = this.vehicleOptionsSelection.bind(this);
    this.handleSubmitVehicleForm2 = this.handleSubmitVehicleForm2.bind(this);
    this.handleSubmitVehicleForm3 = this.handleSubmitVehicleForm3.bind(this);
    // handleUpdateVehicle
  }

  handleChange(date) {
    // console.log(date)
    // console.log("sdasdsad",moment(date, 'DD-MMM-YYYY', true).isValid())

    if (date !== null) {
      this.setState({
        startDate: moment(date).format("YYYY-MM-DD")
      });
    }
  }

  handleChange1(date) {
    if (date !== null) {
      this.setState({
        endDate: moment(date).format("YYYY-MM-DD")
      });
    }
  }

  vehicleOptionsSelection(id, text) {
    let answerArr = [];

    answerArr = this.state.recentAnswer;
    const isIn = answerArr.indexOf(id);

    if (isIn > -1) {
      answerArr.splice(isIn, 1);
    } else {
      answerArr.push(id);
    }
    // console.log('answerArr',answerArr)

    const uniqueArray = [];
    for (let i = 0; i < answerArr.length; i++) {
      if (uniqueArray.indexOf(answerArr[i]) === -1) {
        uniqueArray.push(answerArr[i]);
      }
    }
    // console.log('answerArr',unique_array)

    this.setState({
      recentAnswer: uniqueArray,
      answerIdLatestQ: id,
      answerTextLatestQ: text,
      error: "",
      resentData: 2
    });
    // console.log('answerArr',this.state.recentAnswer)
  }

  saveMultipleVehicleDataResponse = () => {
    const { vehicleDataDtos, vehicleDataExternal1 } = this.state;
    if (this.state.recentAnswer !== undefined) {
      if (this.state.recentAnswer.length > 0) {
        this.state.recentAnswer.map(item => {
          for (let i = 0; i < vehicleDataExternal1.length; i++) {
            if (vehicleDataExternal1[i].vehicleDetailsId === item) {
              vehicleDataDtos.push({
                purchaseDate: "",
                soldDate: "",
                vehicleDetailsId: vehicleDataExternal1[i].vehicleDetailsId,
                trim: vehicleDataExternal1[i].trim,
                vehicleYear: vehicleDataExternal1[i].vehicleYear,
                vehicleMake: vehicleDataExternal1[i].vehicleMake,
                vehicleModel: vehicleDataExternal1[i].vehicleModel,
                vin: vehicleDataExternal1[i].vin,
                fromInfutor: 1,
                vehicleCost: "",
                vehicleType: ""
              });
              // options1.push(<span key={index}><a className="button" >{`${vehicleDataExternal1[i].vehicleYear} ${vehicleDataExternal1[i].vehicleMake} ${vehicleDataExternal1[i].vehicleModel} ${vehicleDataExternal1[i].trim}`}</a></span>)
            }
          }
          return true;
        });
      }
    }
    const data = {
      userId: this.state.userId,
      vehicleDataDtos
    };
    this.props.saveMultipleVehicleData(data);
    this.setState({
      vehicleDataDtos: []
    });
  };

  handleSubmitVehicleForm2() {
    this.saveMultipleVehicleDataResponse();
    this.setState({
      loaded: true
    });
  }

  handleSubmitVehicleForm3() {
    // this.saveMultipleVehicleDataResponse();
    this.setState({
      vehicleFrom1: false,
      vehicleFrom2: false,
      vehicleFrom3: true,
      statePopClose: false
    });
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {},
      errorsTermPolicy: {},
      errorsCompany: {}
    });
  }

  isValidData() {
    const { errors, isValidData } = this.validateInputData(this.state);

    if (!isValidData) {
      this.setState({ errors });
    }
    return isValidData;
  }

  validateInputData(data) {
    // const { vehicleUserData1 } = this.state

    const errors = {};
    if (!data.yearId) {
      errors.yearId = "Year is Required";
      errors.yearIdError = true;
    }
    if (!data.makeId) {
      errors.makeId = "Make is Required";
      errors.makeIdError = true;
    }
    if (!data.modelId) {
      errors.modelId = "Model is Required";
      errors.modelIdError = true;
    }
    if (data.vehicleCostId === "") {
      errors.vehicleCostId = "Purchase type is Required";
      errors.vehicleCostIdError = true;
    }

    // if (vehicleUserData1.findIndex(item => parseInt(item.vehicleYear, 10) === parseInt(data.yearId, 10) && item.vehicleMake === data.makeId && item.vehicleModel === data.modelId && item.vin === data.vin) !== -1) {
    //   if (vehicleUserData1[vehicleUserData1.findIndex(item => parseInt(item.vehicleYear, 10) === parseInt(data.yearId, 10) && item.vehicleMake === data.makeId && item.vehicleModel === data.modelId && item.vin === data.vin)].vehicleDataId !== data.vehicleId) {
    //     errors.vin = 'VIN is already associated with another vehicle.';

    //     errors.vinError = true;
    //   }
    // }

    // if (vehicleUserData1.findIndex(item => parseInt(item.vehicleYear, 10) === parseInt(data.yearId, 10) && item.vehicleMake === data.makeId && item.vehicleModel === data.modelId && item.vin === data.vin) !== -1) {
    //   errors.vin = 'VINs cannot be same for added vehicles';
    //   errors.vinError = true;
    // }

    return {
      errors,
      isValidData: isEmpty(errors)
    };
  }

  handleSubmitVehicle(e) {
    const {
      recentAnswer,
      vin,
      trimId,
      vehicleCostId,
      vehicleTypeId,
      yearId,
      makeId,
      modelId,
      vehicleDataDtos,
      vehicleDataExternal1,
      startDate,
      endDate
    } = this.state;
    e.preventDefault();

    if (recentAnswer !== undefined) {
      if (recentAnswer.length > 0) {
        recentAnswer.map(item => {
          for (let i = 0; i < vehicleDataExternal1.length; i++) {
            if (vehicleDataExternal1[i].vehicleDetailsId === item) {
              vehicleDataDtos.push({
                purchaseDate: "",
                soldDate: "",
                vehicleDetailsId: vehicleDataExternal1[i].vehicleDetailsId,
                trim: vehicleDataExternal1[i].trim || "",
                vehicleYear: vehicleDataExternal1[i].vehicleYear,
                vehicleMake: vehicleDataExternal1[i].vehicleMake,
                vehicleModel: vehicleDataExternal1[i].vehicleModel,
                vin: vehicleDataExternal1[i].vin,
                fromInfutor: 1,
                vehicleCost: "",
                vehicleType: ""
              });
              // options1.push(<span key={index}><a className="button" >{`${vehicleDataExternal1[i].vehicleYear} ${vehicleDataExternal1[i].vehicleMake} ${vehicleDataExternal1[i].vehicleModel} ${vehicleDataExternal1[i].trim}`}</a></span>)
            }
          }
          return true;
        });
      }
    }

    if (this.isValidData()) {
      vehicleDataDtos.push({
        purchaseDate: startDate,
        soldDate: endDate,
        vehicleDetailsId: "",
        trim: trimId,
        vehicleYear: yearId,
        vehicleMake: makeId,
        vehicleModel: modelId,
        vin: vin,
        fromInfutor: "",
        vehicleCost: vehicleCostId,
        vehicleType: vehicleTypeId
      });

      const data = {
        userId: this.state.userId,
        vehicleDataDtos
      };
      this.props.saveMultipleVehicleData(data);
      this.setState({ errors: {}, successSaveState: true, isLoading: true });
      // this.props.addVehicleData(this.state);
    }
    this.setState({
      vehicleDataDtos: []
    });
  }

  handleUpdateVehicle(e) {
    e.preventDefault();
    if (this.isValidData()) {
      this.setState({ errors: {}, isLoading: true });
      this.props.x(this.state);
    }
  }

  handleLog(jsDate) {
    const soldNew = moment(jsDate).format("YYYY-MM-DD");
    const purchaseNew = moment(this.state.startDate).format("YYYY-MM-DD");

    if (purchaseNew < soldNew) {
      this.setState({
        endDate: jsDate
      });
    } else {
      this.setState({
        endDate: null
      });
    }
  }

  handleLog1(jsDate) {
    const purchaseNew = moment(jsDate);
    const soldNew = moment(this.state.endDate);

    if (purchaseNew > soldNew) {
      this.setState({
        endDate: null
      });
    } else {
      this.setState({
        startDate: jsDate
      });
    }
  }

  _yearSelect(e) {
    let newYear;
    this.setState({
      yearId: e.value,
      makeId: "",
      modelId: "",
      trimId: "",
      errors: {},
      fromInfutor: 0,
      vin: ""
    });
    this.props.getAllVehicleModelClear();
    this.props.getAllVehicleTrimClear();
    this.props.getAllVehicleMakeClear();
    this.props.getAllVehicleMake(e.value);
    if (e.value !== "") {
      newYear = new Date().getFullYear() - e.value;
      // console.log("e.value",newYear)

      this.setState({ checkYear: newYear, startDate: "", endDate: null });
    } else {
      this.setState({
        checkYear: new Date().getFullYear(),
        startDate: "",
        endDate: null
      });
    }
    // if(e.value)
  }

  _modelSelect(e) {
    this.setState({
      modelId: e.value,
      errors: {},
      fromInfutor: 0,
      vin: ""
    });
    this.props.getAllVehicleTrimClear();
    const data = {
      vehicleYear: this.state.yearId,
      vehicleMake: this.state.makeId,
      vehicleModel: e.value
    };
    this.props.getAllVehicleTrim(data);
  }

  _trimSelect(e) {
    this.setState({ trimId: e.value });
  }

  _costSelect(e) {
    this.setState({ vehicleCostId: e.value, errors: {} });
  }

  _typeSelect(e) {
    // console.log("sadsadsa disabledDay",e.value)
    if (e.value === "Still Own") {
      this.setState({ disabledDay: "disabled" });
    } else {
      this.setState({ disabledDay: "" });
    }

    this.setState({ vehicleTypeId: e.value, errors: {} });
  }

  async componentDidMount() {
    await this.props.getAllVehicleYear();
    const data = { id: this.state.userId };
    await this.props.getExternalVehicleDataById(data);
  }

  componentWillMount() {}

  componentDidUpdate() {
    const {
      vehicleDataExternalSave,
      autoUdateUser,
      vehicleUserData,
      vehicleViewData,
      addVehicle,
      vehicleDataExternal
    } = this.props.data;
    const {
      vehicleDataExternalSave1,
      autoUdateUserSuccess,
      statePopClose,
      vehicleUserData1,
      addVehicle1,
      vehicleViewData1,
      vehicleDataExternal1
    } = this.state;
    if (vehicleUserData !== undefined) {
      if (vehicleUserData1 !== vehicleUserData) {
        this.setState({ vehicleUserData1: vehicleUserData });
      }
    }
    if (autoUdateUserSuccess !== autoUdateUser) {
      // const userId = localStorage.getItem('userId');
      // this.props.getConsumerUser(userId);
      this.setState({
        autoUdateUserSuccess: autoUdateUser
      });
    }
    if (vehicleDataExternalSave !== undefined) {
      if (vehicleDataExternalSave1 !== vehicleDataExternalSave) {
        if (this.state.vehicleFrom3 === true) {
          this.setState({
            vehicleDataExternalSave1: vehicleDataExternalSave,
            successSaveState: false,
            statePopClose: true,
            loaded: false
          });
        } else {
          this.setState({
            vehicleDataExternalSave1: vehicleDataExternalSave,
            vehicleFrom1: false,
            vehicleFrom2: statePopClose !== true,
            vehicleFrom3: statePopClose === true,
            statePopClose: false,
            loaded: false
          });
        }
        // this.closeModalVehicle();
      }
    }

    if (this.state.successSaveState === true) {
      if (addVehicle !== undefined) {
        if (addVehicle1 !== addVehicle) {
          this.setState({
            addVehicle1: addVehicle,
            successSaveState: false,
            vehicleFrom1: false,
            vehicleFrom2: true,
            vehicleFrom3: false,
            statePopClose: false,
            loaded: false
          });

          setTimeout(() => {
            const userId = localStorage.getItem("userId");
            this.props.updateAutoSettlementFlag({
              userId,
              autoSettlementFlag: "N"
            });
            this.props.getAllVehicleDataByUserId(userId);
          }, 2000);

          // let userId = localStorage.getItem('userId');
          //                    this.props.getAllVehicleDataByUserId(userId);
          // this.closeModalVehicle();
          // this.props.close(false);
          // this.props.successSave();
          // toast.info('Vehicle saved successfully!', {
          //   position: toast.POSITION.TOP_CENTER,
          // });
          // this.props.onSubmit();
        }
      }
    }
    if (vehicleViewData !== undefined) {
      if (vehicleViewData1 !== vehicleViewData) {
        this.setState({
          vehicleViewData1: vehicleViewData
        });
        //   let userId = localStorage.getItem('userId');
        // this.props.getAllVehicleDataByUserId(userId);
      }
    }
    if (vehicleDataExternal !== undefined) {
      if (vehicleDataExternal1 !== vehicleDataExternal) {
        this.setState({
          vehicleDataExternal1: vehicleDataExternal
        });
        if (vehicleDataExternal.length > 0) {
          this.setState({
            vehicleFrom1: true,
            vehicleFrom2: false,
            vehicleFrom3: false,
            statePopClose: false
          });
        } else {
          this.setState({
            vehicleFrom1: false,
            vehicleFrom2: false,
            vehicleFrom3: true,
            statePopClose: false
          });
        }
      }
    }
  }

  deleteVehicleRecords(id) {
    // this.setState({deleteChildStatus:true})
    const data = {
      id,
      userId: localStorage.getItem("userId")
    };
    this.props.deleteVehicleRecordsData(data);
  }

  _makeYearSelect(e) {
    this.setState({
      makeId: e.value,
      errors: {},
      fromInfutor: 0,
      vin: ""
    });
    this.props.getAllVehicleModelClear();
    this.props.getAllVehicleTrimClear();
    const data = {
      vehicleYear: this.state.yearId,
      vehicleMake: e.value
    };
    this.props.getAllVehicleModel(data);

    // getAllVehicleModel
  }

  viewVehicleEdit(
    id,
    purchaseDate,
    soldDate,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleDetailsId,
    vin,
    vehicleType,
    vehicleCost,
    fromInfutor,
    viewStatus
  ) {
    // console.log("vehicleDetailsId",purchaseDate)

    this.props.getAllVehicleMake(vehicleYear);
    const data = {
      vehicleYear,
      vehicleMake
    };
    const data1 = {
      vehicleYear,
      vehicleMake,
      vehicleModel
    };
    if (vehicleType === "Still Own") {
      this.setState({ disabledDay: "disabled" });
    } else {
      this.setState({ disabledDay: "" });
    }

    this.props.getAllVehicleTrim(data1);

    this.props.getAllVehicleModel(data);
    this.setState({
      vin,
      modalIsOpenVehicle: true,
      yearId: Number.parseInt(vehicleYear, 10),
      makeId: vehicleMake,
      modelId: vehicleModel,
      trimId: vehicleDetailsId,
      startDate: purchaseDate,
      endDate: soldDate,
      showButton1: false,
      showUpadeButtonR: true,
      vehicleId: id,
      vehicleTypeId: vehicleType,
      fromInfutor,
      vehicleCostId: vehicleCost
    });

    if (viewStatus === "view") {
      this.setState({ showButton1: false });
    } else {
      // this.setState({showButton1:true})
      // this.props.viewVehicleEditRecord(this.state)
    }

    // console.log(viewStatus)
    // console.log(id)
  }

  handleSeletcedYearChangeConsumer(date) {
    this.setState({ cSince: date });
  }

  openModalVehicle() {
    this.setState({
      modalIsOpenVehicle: true,
      showButton1: true,
      showUpadeButtonR: false,
      yearId: "",
      makeId: "",
      modelId: "",
      trimId: "",
      startDate: "",
      endDate: "",
      vin: "",
      vehicleCostId: "",
      vehicleTypeId: "",
      disabledDay: "",
      vehicleId: ""
    });
  }

  closeModalVehicle(e) {
    e.preventDefault();
    if (this.state.vehicleFrom2 === true || this.state.statePopClose === true) {
      this.props.successSave();
    }
    this.setState({
      modalIsOpenVehicle: false,
      userId: localStorage.getItem("userId"),
      yearId: "",
      makeId: "",
      modelId: "",
      trimId: "",
      startDate: "",
      endDate: "",
      vin: "",
      errors: {},
      vehicleUserData1: [],
      showButton1: true,
      addVehicle1: [],
      showUpadeButtonR: true,
      vehicleId: "",
      vehicleViewData1: "",
      date: new Date(),
      vehicleCostId: "",
      vehicleTypeId: "",
      disabledDay: false,
      checkYear: new Date().getFullYear(),
      successSaveState: false,
      vehicleFrom1: false,
      vehicleFrom2: false,
      vehicleFrom3: false,
      statePopClose: false,
      vehicleDataExternal1: [],
      recentAnswer: []
    });
    this.props.close(false);
  }

  afterOpenModal() {}

  render() {
    const {
      yearId,
      errors,
      startDate,
      vehicleDataExternal1,
      loaded,
      endDate,
      vehicleFrom1,
      vehicleFrom2,
      vehicleFrom3,
      vehicleCostId,
      disabledDay,
      vehicleTypeId,
      showButton1,
      vin,
      modelId,
      makeId,
      trimId,
      fromInfutor
    } = this.state;
    const {
      vehicleYear,
      vehicleMoel,
      vehicleTrim,
      vehicleMake
    } = this.props.data;

    const optionsYear = [];
    optionsYear.push({ value: "", label: "Year", name: "Year" });
    if (vehicleYear !== undefined) {
      vehicleYear.map(item =>
        optionsYear.push({ value: item, label: item, name: item })
      );
    }

    const cSelectedYear = _.find(optionsYear, { value: yearId });
    const cDefaultOptionYear = cSelectedYear;
    // make
    const optionsMake = [];
    optionsMake.push({ value: "", label: "Make", name: "Make" });
    if (vehicleMake !== undefined) {
      vehicleMake.map(item =>
        optionsMake.push({ value: item, label: item, name: item })
      );
    }

    const cSelectedMake = _.find(optionsMake, { value: makeId });
    const cDefaultOptionMake = cSelectedMake;

    // this.setState({cSince : ConsumerUserData.beginYear,state:ConsumerUserData.cState});

    const optionsModel = [];
    optionsModel.push({ value: "", label: "Model", name: "Model" });

    if (vehicleMoel !== undefined) {
      vehicleMoel.map(item =>
        optionsModel.push({ value: item, label: item, name: item })
      );
    }
    const cSelectedModel = _.find(optionsModel, { value: modelId });
    const cDefaultOptionModel = cSelectedModel;

    const optionsTrim = [];
    optionsTrim.push({ value: "", label: "Trim", name: "Trim" });

    if (vehicleTrim !== undefined) {
      if (vehicleTrim.length > 0) {
        vehicleTrim.map(item => {
          if (item.trim !== "") {
            if (item.trim !== undefined) {
              return optionsTrim.push({
                value: item.trim,
                label: item.trim,
                name: item.trim
              });
            }
          }
          return true;
        });
      }
    }
    const cSelectedTrim = _.find(optionsTrim, { value: trimId });
    const cDefaultOptionTrim = cSelectedTrim;

    const optionsVehicleCost = [];
    optionsVehicleCost.push({
      value: "",
      label: "Purchase Type",
      name: "Purchase Type"
    });
    optionsVehicleCost.push({
      value: "Leased",
      label: "Leased",
      name: "Leased"
    });
    optionsVehicleCost.push({
      value: "Purchased New",
      label: "Purchased New",
      name: "Purchased New"
    });
    optionsVehicleCost.push({
      value: "Purchased Used",
      label: "Purchased Used",
      name: "Purchased Used"
    });

    const cSelectedVehicleCost = _.find(optionsVehicleCost, {
      value: vehicleCostId
    });
    const cDefaultVehicleCost = cSelectedVehicleCost;

    const optionsVehicleType = [];
    optionsVehicleType.push({
      value: "",
      label: "Current Status",
      name: "Current Status"
    });
    optionsVehicleType.push({
      value: "Still Own",
      label: "Still Owned",
      name: "Still Owned"
    });
    optionsVehicleType.push({ value: "Sold", label: "Sold", name: "Sold" });
    const options1 = [];
    const options = [];
    const cSelectedVehicleType = _.find(optionsVehicleType, {
      value: vehicleTypeId
    });
    const cDefaultVehicleType = cSelectedVehicleType;
    if (vehicleDataExternal1 !== undefined) {
      if (vehicleDataExternal1.length > 0) {
        vehicleDataExternal1.map((item, index) => {
          options.push(
            <span key={index}>
              <a
                className={
                  this.state.recentAnswer.indexOf(item.vehicleDetailsId) > -1
                    ? "button active"
                    : "button"
                }
                onClick={() =>
                  this.vehicleOptionsSelection(item.vehicleDetailsId)
                }
              >{`${item.vehicleYear} ${item.vehicleMake
                .charAt(0)
                .toUpperCase() + item.vehicleMake.substr(1)} ${
                item.vehicleModel
              } ${item.trim !== undefined ? item.trim : ""}`}</a>
            </span>
          );
          return true;
        });
      }
    }
    if (this.state.updateAnswer !== undefined) {
      if (this.state.updateAnswer.length > 0) {
        this.state.updateAnswer.map((item, index) => {
          for (let i = 0; i < vehicleDataExternal1.length; i++) {
            if (vehicleDataExternal1[i].vehicleDetailsId === item) {
              options1.push(
                <span key={index}>
                  <a className="button">{`${
                    vehicleDataExternal1[i].vehicleYear
                  } ${vehicleDataExternal1[i].vehicleMake} ${
                    vehicleDataExternal1[i].vehicleModel
                  } ${
                    vehicleDataExternal1[i].trim !== undefined
                      ? vehicleDataExternal1[i].trim
                      : ""
                  }`}</a>
                </span>
              );
            }
          }
          return true;
        });
      }
    }

    let loader1;
    if (loaded) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <span>
        {loader1}

        <Modal
          isOpen={this.props.open}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalVehicle}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
          shouldCloseOnOverlayClick={false}
          className="add-vehicle-modal"
        >
          <div className="modal-content addvehicle-content">
            <div className="icon-preview addvehicle-cross">
              <a href="" onClick={this.closeModalVehicle}>
                <i className="material-icons dp48">close</i>
              </a>
            </div>
            <div className="col s12 m7 hdr">
              <h4> {showButton1 === true ? "Add" : "Update"} Vehicles</h4>
            </div>
            <div className={vehicleFrom1 ? "row" : "hide"}>
              <span className="vehicle-pop">
                <div className="col s12">
                  <h6 className="select-vehicle">Select Vehicles</h6>
                  <div className="following-cities drop_c_width">{options}</div>
                  <p>
                    Select any vehicles you may have owned or leased to add them
                    to you profile. Click 'Add More Vehicles' if you have any
                    which are not listed.
                  </p>
                </div>
              </span>
              <div className="center-align">
                <button
                  onClick={this.handleSubmitVehicleForm2}
                  className="btn waves-effect waves-light primary-btn update-profile vehiclepop-btn"
                  type="submit"
                >
                  Save
                  <i className="material-icons">arrow_forward</i>
                </button>
                <button
                  onClick={this.handleSubmitVehicleForm3}
                  className="btn waves-effect waves-light primary-btn update-profile vehiclepop-btn"
                  type="submit"
                >
                  Add More Vehicles
                  <i className="material-icons">arrow_forward</i>
                </button>
              </div>
            </div>
            <div className={vehicleFrom2 ? "row" : "hide"}>
              <AddVehicleInModalSuccess vehicleFrom2={vehicleFrom2} />
            </div>
            <div className={vehicleFrom3 ? "row" : "hide"}>
              <div className="col s12">
                <div className="grey-box">
                  <div className="grey-inner">
                    <div className="input-field half-field padding-field">
                      {/* <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsYear}
                        onChange={this._yearSelect}
                        value={cDefaultOptionYear}
                        placeholder="Select an option"
                      /> */}
                      <Select
                        theme={theme => ({
                          ...theme,
                          border: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "01a8f9",
                            primary: "#039be5"
                          }
                        })}
                        name="year"
                        className="browser-default"
                        options={optionsYear}
                        onChange={this._yearSelect}
                        value={cDefaultOptionYear}
                        placeholder="Select an option"
                      />
                      <span
                        className={errors.yearIdError ? "show invalid" : "hide"}
                      >
                        {errors.yearId}
                      </span>
                    </div>

                    <div className="input-field half-field ">
                      {/* <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsMake}
                        onChange={this._makeYearSelect}
                        value={cDefaultOptionMake}
                        placeholder="Select an option"
                      /> */}
                      <Select
                        theme={theme => ({
                          ...theme,
                          border: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "01a8f9",
                            primary: "#039be5"
                          }
                        })}
                        name="year"
                        className="browser-default"
                        options={optionsMake}
                        onChange={this._makeYearSelect}
                        value={cDefaultOptionMake}
                        placeholder="Select an option"
                      />
                      <span
                        className={errors.makeIdError ? "show invalid" : "hide"}
                      >
                        {errors.makeId}
                      </span>
                    </div>

                    <div className="input-field half-field padding-field">
                      {/* <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsModel}
                        onChange={this._modelSelect}
                        value={cDefaultOptionModel}
                        placeholder="Select an option"
                      /> */}
                      <Select
                        theme={theme => ({
                          ...theme,
                          border: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "01a8f9",
                            primary: "#039be5"
                          }
                        })}
                        name="year"
                        className="browser-default"
                        options={optionsModel}
                        onChange={this._modelSelect}
                        value={cDefaultOptionModel}
                        placeholder="Select an option"
                      />
                      <span
                        className={
                          errors.modelIdError ? "show invalid" : "hide"
                        }
                      >
                        {errors.modelId}
                      </span>
                    </div>

                    <div className="input-field half-field">
                      {/* <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsTrim}
                        onChange={this._trimSelect}
                        value={cDefaultOptionTrim}
                        placeholder="Select an option"
                      /> */}
                      <Select
                        theme={theme => ({
                          ...theme,
                          border: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "01a8f9",
                            primary: "#039be5"
                          }
                        })}
                        name="year"
                        className="browser-default"
                        options={optionsTrim}
                        onChange={this._trimSelect}
                        value={cDefaultOptionTrim}
                        placeholder="Select an option"
                      />
                    </div>
                    <div className="input-field half-field padding-field">
                      {/* <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsVehicleCost}
                        onChange={this._costSelect}
                        value={cDefaultVehicleCost}
                        placeholder="Select an option"
                      /> */}

                      <Select
                        theme={theme => ({
                          ...theme,
                          border: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "01a8f9",
                            primary: "#039be5"
                          }
                        })}
                        name="year"
                        className="browser-default"
                        options={optionsVehicleCost}
                        onChange={this._costSelect}
                        value={cDefaultVehicleCost}
                        placeholder="Select an option"
                      />
                      <span
                        className={
                          errors.vehicleCostIdError ? "show invalid" : "hide"
                        }
                      >
                        {errors.vehicleCostId}
                      </span>
                    </div>

                    <div className="input-field half-field ">
                      {/* <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsVehicleType}
                        onChange={this._typeSelect}
                        value={cDefaultVehicleType}
                        placeholder="Select an option"
                      /> */}
                      <Select
                        theme={theme => ({
                          ...theme,
                          border: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "01a8f9",
                            primary: "#039be5"
                          }
                        })}
                        name="year"
                        className="browser-default"
                        options={optionsVehicleType}
                        onChange={this._typeSelect}
                        value={cDefaultVehicleType}
                        placeholder="Select an option"
                      />
                    </div>

                    <div className="input-field full-field">
                      <TextFieldGroupVin
                        field="vin"
                        label="vin"
                        value={vin}
                        error={errors.vin}
                        onChange={this.onChange}
                        fromInfutor={fromInfutor === 1 ? true : false}
                      />
                    </div>
                    <div className="input-field half-field padding-field">
                      <DatePickerInput
                        showOnInputClick
                        onChange={this.handleLog1}
                        value={startDate}
                        className="my-custom-datepicker-component"
                        autoClose
                        placeholder="Purchase Date"
                        minDate={moment()
                          .subtract(2020 - (yearId-1), "year",).startOf("month").startOf("year")
                          .toDate()}
                        maxDate={moment()}
                        locale="en-au"
                        displayFormat="MM-DD-YYYY"
                        position="top"
                      />
                    </div>

                    <div className="input-field  half-field">
                      <DatePickerInput
                        showOnInputClick
                        onChange={this.handleLog}
                        value={endDate}
                        displayFormat="MM-DD-YYYY"
                        className="my-custom-datepicker-component"
                        autoClose
                        placeholder="Sold Date"
                        minDate={
                          startDate !== null && startDate !== ""
                            ? startDate
                            : this.state.checkYear !== 0
                            ? moment()
                                .subtract(this.state.checkYear, "year")
                                .toDate()
                            : moment()
                                .startOf("year")
                                .toDate()
                        }
                        // minDate={
                        //   moment()
                        //     .subtract(this.state.checkYear, "year")
                        //     .toDate() &&
                        //   (startDate !== null && startDate !== "")
                        //     ? startDate
                        //     : moment()
                        //         .add(1, "days")
                        //         .format("DD-MM-YYYY")
                        // }
                        maxDate={moment()}
                        disabled={disabledDay}
                        locale="en-au"
                        position="top"
                      />
                    </div>

                    <div className="input-field full-field save-button">
                      <button
                        onClick={this.handleSubmitVehicle}
                        className={
                          showButton1 === true
                            ? "btn waves-effect waves-light primary-btn update-profile"
                            : "hide"
                        }
                        type="submit"
                        name="action"
                      >
                        Save
                        <i className="material-icons">arrow_forward</i>
                      </button>
                      <button
                        onClick={this.closeModalVehicle}
                        style={{ marginLeft: "5px" }}
                        className="btn waves-effect waves-light primary-btn update-profile"
                        type="submit"
                        name="action"
                      >
                        Cancel
                        <i className="material-icons">arrow_forward</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </span>
    );
  }
}

AddVehicleInModal.contextTypes = {
  router: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  data: state.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllVehicleYear,
      getExternalVehicleDataById,
      getAllVehicleMake,
      getAllVehicleModel,
      getAllVehicleTrim,
      addVehicleData,
      getAllVehicleDataByUserId,
      deleteVehicleRecordsData,
      viewVehicleEditRecord,
      saveMultipleVehicleData,
      getAllVehicleModelClear,
      getAllVehicleTrimClear,
      getAllVehicleMakeClear,
      getConsumerUser,
      updateAutoSettlementFlag
    },
    dispatch
  );

export default withAlert(
  connect(mapStateToProps, mapDispatchToProps)(AddVehicleInModal)
);

// export default Profile;
